import { Typography, Modal, CircularProgress } from "@mui/material";
import { Box } from "@mui/system";

export const CreateOrderLoadingModal = ({ isLoading }) => {
  return (
    <Modal open={isLoading}>
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          backgroundColor: "#FFFFFF",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <CircularProgress />
        <Typography mt={"16px"}>Создание заявки...</Typography>
        <Typography mt={"16px"}>Не покидайте страницу</Typography>
      </Box>
    </Modal>
  );
};
